var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Api } from "./api";
var SwingBySwingApi = /** @class */ (function (_super) {
    __extends(SwingBySwingApi, _super);
    function SwingBySwingApi() {
        var _this = this;
        // Get the current URL
        var getUrl = window.location;
        var baseUrl = getUrl.protocol + "//" + getUrl.host;
        // Set the API URL
        _this = _super.call(this, baseUrl + "/api") || this;
        return _this;
    }
    return SwingBySwingApi;
}(Api));
export { SwingBySwingApi };
